import { Link } from 'react-router-dom'

import { useHostProfileUrl } from '@/hooks/useHostProfileUrl'
import { ArrowLeft } from '../../assets/icons/ArrowLeft'
import { Logo } from '../../assets/icons/Logo'
import { LogoFr } from '../../assets/icons/LogoFr'
import { Profile } from '../../assets/icons/Profile'
import { useAppSelector } from '../../hooks/store'
import { useBackLink } from '../../hooks/useBackLink'
import { AppMode, Country } from '../../models/app'
import { appSlice } from '../../store/appSlice'

export const TopBar = () => {
  const mode = useAppSelector(appSlice.selectors.mode)
  const country = useAppSelector(appSlice.selectors.country)
  const backLink = useBackLink()
  const { hostUrl, profileUrl } = useHostProfileUrl()

  if (mode !== AppMode.WEBSITE) return null

  return (
    <div className="text-primary-inverted bg-brand py-4">
      <div className="container flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          {backLink ? (
            <Link to={backLink}>
              <ArrowLeft className="size-8" />
            </Link>
          ) : null}

          <a href={hostUrl}>
            {country === Country.IT ? <Logo className="h-8 w-auto" /> : null}
            {country === Country.FR ? <LogoFr className="h-8 w-auto" /> : null}
          </a>
        </div>

        <a href={profileUrl}>
          <Profile className="size-8" />
        </a>
      </div>
    </div>
  )
}
